import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
    Col,
    InputMask,
    Row,
    Span,
    Form,
    Grid,
    Button,
    RadioGroup,
    Picker
} from 'components'
import {
    withDateColor,
    rangeIsInvalid,
    hasInvalidDate,
    rangeIsInvalidNumber
} from 'components/DatePicker/utils'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import {
    EffectiveParamsServices,
    IEffectiveParams
} from 'services/NGT/EffectiveParams'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import * as Yup from 'yup'
import { Form as FormUnidadeGestora } from 'components/UnidadeGestoraFields/types'
import { Style } from '@mui/icons-material'
import { RequestlogicalEffectiveParams, logicalEffectiveParams, logicalEffectiveParamsServices } from 'services/NGT/logicalEffetiveParams'


const LogicalEffective: React.FC = () => {
    const schema = Yup.object({
        qtDiasPrimeiraCobranca: Yup.string().required('Campo obrigatório'),
        qtDiasSegundaCobranca: Yup.string().required('Campo obrigatório'),
        qtDiasTerceiraCobranca: Yup.string().required('Campo obrigatório'),
        qtDiasBloqueio: Yup.string().required('Campo obrigatório')
    })

    const {
        control,
        handleSubmit,
        setValue,
        reset,
        watch,
        formState: { errors }
    } = useForm<logicalEffectiveParams>({
        defaultValues: {
            qtDiasPrimeiraCobranca: 0,
            qtDiasSegundaCobranca: 0,
            qtDiasTerceiraCobranca: 0,
            qtDiasBloqueio: 0
        },
        resolver: yupResolver(schema)
    })

    const { setLoading } = useLoading()
    const [isModalOpen, toggleModal] = useToggle()
    const { showModal } = useModal()
    const [matricula, setMatricula] = useState('')
    const [logicalEffectiveParamsData, setEffectiveParamsData] = useState<logicalEffectiveParams>()

    const data = watch()

    const updateLogicalEffectiveParams = async () => {
        const updatedData = {
            qtDiasBloqueio: data?.qtDiasBloqueio,
            qtDiasPrimeiraCobranca: data?.qtDiasPrimeiraCobranca,
            qtDiasSegundaCobranca: data?.qtDiasSegundaCobranca,
            qtDiasTerceiraCobranca: data?.qtDiasTerceiraCobranca
        } as RequestlogicalEffectiveParams

        if (rangeIsInvalidNumber(updatedData.qtDiasPrimeiraCobranca, updatedData.qtDiasSegundaCobranca)) {
            showModal({
                hideButtonCancel: true,
                message: 'A quantidade de dias da segunda cobrança deve ser maior que a primeira cobrança.',
                txtButtonConfirm: 'OK',
                type: 'alert'
            })
            return;
        }
        if (rangeIsInvalidNumber(updatedData.qtDiasSegundaCobranca, updatedData.qtDiasTerceiraCobranca) && (updatedData.qtDiasPrimeiraCobranca, updatedData.qtDiasTerceiraCobranca)) {
            showModal({
                hideButtonCancel: true,
                message: 'A quantidade de dias da terceira cobrança deve ser maior que a segunda e a primeira cobrança.',
                txtButtonConfirm: 'OK',
                type: 'alert'
            });
            return
        }
        if (rangeIsInvalidNumber(updatedData.qtDiasTerceiraCobranca, updatedData.qtDiasBloqueio)) {
            showModal({
                hideButtonCancel: true,
                message: 'A quantidade de dias do bloqueio deve ser maior que a terceira cobrança.',
                txtButtonConfirm: 'OK',
                type: 'alert'
            });
            return

        }


        setLoading('loading')

        try {
            await logicalEffectiveParamsServices().createOrUpdate(updatedData).then(() => {
                showModal({
                    hideButtonCancel: true,
                    message: 'Dados atualizados com sucesso.',
                    txtButtonConfirm: 'OK',
                    type: 'success',
                });
            })

        }
        catch (error: any) {
            showModal({
                hideButtonCancel: true,
                message: error.message ?? 'Erro ao atualizar os dados do módulo de Parametrização Efetivos Lógico.',
                txtButtonConfirm: 'OK',
                type: 'alert'
            })
        }
        setLoading('idle')
    }

    useEffect(() => {
        setLoading('loading');
        logicalEffectiveParamsServices()
            .get()
            .then(({ data }) => {
                setEffectiveParamsData(data[0])
                const effectiveParams = data;
                setValue('qtDiasPrimeiraCobranca', effectiveParams?.qtDiasPrimeiraCobranca);
                setValue('qtDiasSegundaCobranca', effectiveParams?.qtDiasSegundaCobranca);
                setValue('qtDiasTerceiraCobranca', effectiveParams?.qtDiasTerceiraCobranca);
                setValue('qtDiasBloqueio', effectiveParams?.qtDiasBloqueio);
                setValue('txMatricula', `Matrícula:${effectiveParams.txMatricula}`);
                setValue('updatedDate', effectiveParams.updatedDate);
                setMatricula(effectiveParams.txMatricula);
                setLoading('idle');
                //toggleModal();
            })
            .catch((err) => {
                showModal({
                    hideButtonCancel: true,
                    message: err.title || 'Erro ao obter os dados do módulo de Parametrização Efetivos Lógico.',
                    txtButtonConfirm: 'OK',
                    type: 'alert'
                })
                setLoading('idle')
            });
    }, []);


    return (
        <>
            <Form
                onSubmit={handleSubmit(
                    updateLogicalEffectiveParams)}
                marginLeft={SPACING.spacing20}
                marginRight={SPACING.spacing20}
                marginBottom={SPACING.spacing100}
                padding={SPACING.spacing20}
                boxShadow={`0 0 1em ${COLORS.lightGray}`}
            >
                <Col gap='1rem'>
                    <Row gap='1rem' alignItems='center'>
                        <Grid
                            gridCols="1fr 1fr 1fr"
                            gridGap={`0 ${SPACING.spacing30}`}
                            margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
                        >
                            <InputMask
                                label='Qtd. Dias primeira cobrança'
                                control={control}
                                errors={errors}
                                formValue="qtDiasPrimeiraCobranca"
                                placeholder='Qtd'
                                type='qtd'
                                width='12rem'
                                required
                                maxLength={4}
                            />
                            <InputMask
                                label='Qtd. Dias segunda cobrança'
                                control={control}
                                errors={errors}
                                formValue="qtDiasSegundaCobranca"
                                placeholder='Qtd'
                                type='qtd'
                                width='12rem'
                                required
                                maxLength={4}
                            />
                            <InputMask
                                label='Qtd. Dias terceira cobrança'
                                control={control}
                                errors={errors}
                                formValue="qtDiasTerceiraCobranca"
                                placeholder='Qtd'
                                type='qtd'
                                width='12rem'
                                required
                                maxLength={4}
                            />
                        </Grid>
                    </Row>
                    <Row alignItems="center" gap="2rem" marginBottom={`${SPACING.spacing30}`}>
                        <Col gap="1rem">
                            <Grid
                                gridCols="1fr 1fr 1fr"
                                gridGap={`0 ${SPACING.spacing30}`}
                                margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
                            >
                                <InputMask
                                    label='Qtd. Dias realização de bloqueio'
                                    control={control}
                                    errors={errors}
                                    formValue="qtDiasBloqueio"
                                    placeholder='Qtd'
                                    type='qtd'
                                    width='12rem'
                                    required
                                    maxLength={4}
                                />
                            </Grid>
                        </Col>
                    </Row>
                </Col>
                <Row alignItems="center" gap="2rem">
                    <Col gap='1rem'>
                        <Picker
                            label='Última atualização'
                            type="dayMonthYear"
                            allowTyping={false}
                            formValue='updatedDate'
                            control={control}
                            errors={errors}
                            disabled
                            placeholder="Inicial"
                            width='10rem'
                        />
                    </Col>
                    <Col>
                        <InputMask
                            label='Atualizado por:'
                            control={control}
                            errors={errors}
                            disabled
                            formValue='txMatricula'
                            placeholder='Matrícula'
                            width='9rem'
                        />
                    </Col>
                </Row>
                <Row justifyContent="flex-end">
                    <Button text="Salvar" type="submit" marginRight={SPACING.spacing30} />
                </Row>
            </Form >

        </>
    )
}
export default LogicalEffective;
